module.exports = __webpack_public_path__ + "media/images/favicons/ms-icon-70x70-e2b2bc6eb5cbea2cf83fac8091c42da5.png";